import React, { Component } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Accordion, Icon, Image, Label, Message, Step, Table, Segment, Modal, Button, Header, Form, Feed, Popup } from 'semantic-ui-react';
import moment from 'moment';
import { storageURI, capitalizeKey } from '../config';
import { processQuote, cancelQuote, addNoteQuotation } from '../actions';


class QuotationDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            cartOpen: true,
            logOpen: false,
            quoteID: -1,
            addNoteDialog: false,
            processDialog: false,
            cancelDialog: false,
            paymentChecked: true,
            paymentMethod: 'Cash',
            cancellationNote: '',
            miscNote: ''
        }

        window.Handlebars.registerHelper('ifEquals', function (arg1, arg2, options) {
            return (arg1 == arg2) ? options.fn(this) : options.inverse(this);
        });

        window.Handlebars.registerHelper('currency', function (value) {
            return value.toFixed(2);
        });

        window.Handlebars.registerHelper('date', function (date) {
            return moment(date).format('DD/MM/YYYY');
        });

        window.Handlebars.registerHelper('math', function (lvalue, operator, rvalue, options) {
            lvalue = parseFloat(lvalue);
            rvalue = parseFloat(rvalue);

            return {
                "+": lvalue + rvalue,
                "-": lvalue - rvalue,
                "*": lvalue * rvalue,
                "/": lvalue / rvalue,
                "%": lvalue % rvalue
            }[operator];
        });

        window.Handlebars.registerHelper('showKey', function (value) {
            const capitalize = text => text
                .split('_')
                .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
                .join(' ');
            return capitalize(value);
        });

        window.Handlebars.registerHelper('ifIncludes', function (arg1, arg2, options) {
            return (arg1.toString().includes(arg2)) ? options.fn(this) : options.inverse(this);
        });

        window.Handlebars.registerHelper('isNo', function (value) {
            if (value === 'No')
                return;
        });

        window.Handlebars.registerHelper('Uppercase', function (value) {
            return value.toUpperCase();
        });

        window.Handlebars.registerHelper('currency4dec', function (value) {
            return value.toFixed(4);
        });
    }

    componentWillMount() {
        console.log(this.props)
        let quote_id = this.props.match.params.quote_id;
        let quote = this.props.quote.quote_list.find((n) => n._id === quote_id);

        this.setState({ quoteID: quote_id, selectedQuote: quote });
    }

    componentWillReceiveProps(nextProps) {
        let oldQuote = this.props.quote.quote_list.find((n) => n._id === this.state.quoteID);
        let newQuote = nextProps.quote.quote_list.find((n) => n._id === this.state.quoteID);
        if ((oldQuote.status === 'Submitted') && (newQuote.status === 'Approved')) {
            this.setState({ processDialog: false });
        } else if ((oldQuote.status !== 'Canceled') && (newQuote.status === 'Canceled')) {
            this.setState({ cancelDialog: false });
        } else if ((oldQuote.notes) && (oldQuote.notes !== newQuote.notes)) {
            this.setState({ addNoteDialog: false });
        } else if ((!oldQuote.notes) && (newQuote.notes)) {
            this.setState({ addNoteDialog: false });
        }

        if (newQuote) this.setState({ selectedQuote: newQuote });
    }

    handleCartClick() {
        this.setState({ cartOpen: !this.state.cartOpen });
    }

    handleLogClick() {
        this.setState({ logOpen: !this.state.logOpen });
    }

    handleAddNote() {
        this.setState({ addNoteDialog: true });
    }

    handleprocessQuote() {
        this.setState({ processDialog: true });
    }

    handlecancelQuote() {
        this.setState({ cancelDialog: true });
    }

    handleMiscNoteInput(e) {
        this.setState({ miscNote: e.target.value });
    }

    handleCancellationNoteInput(e) {
        this.setState({ cancellationNote: e.target.value });
    }

    closeAddNoteDialog() {
        this.setState({ addNoteDialog: false });
    }

    closeProcessDialog() {
        this.setState({ processDialog: false });
    }

    closeCancelDialog() {
        this.setState({ cancelDialog: false });
    }

    submitNote() {
        this.props.addNoteQuotation({
            quoteID: this.state.quoteID,
            user: this.props.user,
            note: this.state.miscNote,
        });
    }

    handlePrintQuotation() {
        console.log(this.state.selectedQuote);
        let html = window.Handlebars.templates.quotation(this.state.selectedQuote);
        let strWindowFeatures = "menubar=yes,location=no,resizable=no,scrollbars=yes,status=no";
        // window.open(window.location.hostname + ':' + window.location.port + html, "_blank", strWindowFeatures);
        let stmt_wnd = window.open("", "_blank");
        stmt_wnd.document.write(html);
    }

    approveQuote() {
        this.props.processQuote({
            quoteID: this.state.quoteID,
            processInput: {
                verifier: this.props.user,
            }
        });

        this.setState({ paymentChecked: true });
    }

    cancelQuote() {
        this.props.cancelQuote({
            quoteID: this.state.quoteID,
            staff: this.props.user,
            note: this.state.cancellationNote
        });
        this.setState({ cancelDialog: false });
    }

    renderLogs(selectedQuote) {
        let logs = [];

        if (selectedQuote.approval) {
            let entry = {
                time: selectedQuote.approval.date,
                icon: 'check',
                content: <Feed.Extra text>Approved by <b>{selectedQuote.approval.name}</b> {'<' + selectedQuote.approval.email + '>'}</Feed.Extra>
            }
            logs.push(entry);
        }

        // if (selectedQuote.payment) {
        //     let entry;
        //     if (selectedQuote.payment.method === 'In-Store Credit') {
        //         entry = {
        //             time: selectedQuote.payment.date,
        //             icon: 'money',
        //             content: <Feed.Extra text>Payment made via <b>{selectedQuote.payment.method}</b></Feed.Extra>
        //         }
        //     }

        //     logs.push(entry);
        // }

        if (selectedQuote.cancellation) {
            let entry = {
                time: selectedQuote.cancellation.canceled_at,
                icon: 'trash',
                content: <Feed.Extra text>Cancellation made by <b>{selectedQuote.cancellation.name}</b> {'<' + selectedQuote.cancellation.email + '>'} with note "<b>{selectedQuote.cancellation.note}</b>"</Feed.Extra>
            }
            logs.push(entry);
        }

        // if (selectedQuote.shipment) {
        //     let entry;
        //     if (selectedQuote.shipment.courier === 'Self Collect') {
        //         entry = {
        //             time: selectedQuote.shipment.updated_at,
        //             icon: 'inbox',
        //             content: <Feed.Extra text>Self collection was arranged by <b>{selectedQuote.shipment.shipped_by.name}</b></Feed.Extra>
        //         }
        //         // } else {
        //         //     entry = {
        //         //         time: selectedQuote.shipment.updated_at,
        //         //         icon: 'truck',
        //         //         content: <Feed.Extra text>Shipped via <b>{metaToString(selectedQuote.shipment.courier)}</b> with tracking number <a href={trackingURL + selectedQuote.shipment.tracking} target='_blank'><b>{selectedQuote.shipment.tracking}</b></a> was arranged by <b>{selectedQuote.shipment.shipped_by.name}</b></Feed.Extra>
        //         //     }
        //     }
        //     logs.push(entry);
        // }

        if (selectedQuote.notes) {
            selectedQuote.notes.forEach((note) => {
                let entry = {
                    time: note.updated_at,
                    icon: 'file text outline',
                    content: <Feed.Extra text><b>{note.user.name}</b> added note with "<b>{note.note}</b>"</Feed.Extra>
                }
                logs.push(entry);
            });
        }

        let new_logs = _.sortBy(logs, ['time']);

        return new_logs.map((entry, index) => (
            <Feed key={index}>
                <Feed.Event>
                    <Feed.Label>
                        <Icon name={entry.icon} />
                    </Feed.Label>
                    <Feed.Content>
                        <Feed.Date>{moment(entry.time).format('DD/MM/YYYY HH:mm')}</Feed.Date>
                        {entry.content}
                    </Feed.Content>
                </Feed.Event>
            </Feed>
        ));
    }


    render() {
        const { logOpen, cartOpen, selectedQuote, cancellationNote, miscNote, addNoteDialog, processDialog, cancelDialog } = this.state;
        console.log(selectedQuote);

        let status_icon = '';
        let status_color = '';

        if (selectedQuote.status === 'Approved') {
            status_icon = 'check circle';
            status_color = 'green';
        }
        else if (selectedQuote.status === 'Submitted') {
            status_icon = 'add circle';
            status_color = 'teal';
        } else {
            status_icon = 'remove circle';
            status_color = 'red';
        }

        return (
            <div style={{ marginTop: '2em' }}>
                <Segment.Group>
                    <Segment>
                        <b>Quotation #{selectedQuote._id}</b>
                        <div style={{ float: 'right' }}>
                            <Popup
                                trigger={<Icon bordered className="clickable" name="print" onClick={this.handlePrintQuotation.bind(this)} />}
                                content='Print Quotation'
                                style={{ opacity: 0.7 }}
                                inverted
                            />
                            <Popup
                                trigger={<Icon className="clickable" bordered name='edit' onClick={this.handleAddNote.bind(this)} />}
                                content='Add Note'
                                style={{ opacity: 0.7 }}
                                inverted
                            />
                        </div>
                    </Segment>
                    <Segment.Group horizontal>
                        <Segment>
                            <Icon name='payment' /><b>Quotation Details</b>
                            <Table basic='very' compact='very'>
                                <Table.Body>
                                    <Table.Row>
                                        <Table.Cell>Quote Date</Table.Cell>
                                        <Table.Cell>{moment(selectedQuote.quote_date).format('DD/MM/YYYY HH:mm')}</Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell>Total Amount</Table.Cell>
                                        <Table.Cell>RM {selectedQuote.quote_details.total_amount.toFixed(2)}</Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell>Payment Terms</Table.Cell>
                                        <Table.Cell>{selectedQuote.quote_details.payment_terms}</Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell>Process Days</Table.Cell>
                                        <Table.Cell>{selectedQuote.quote_details.process_days}</Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell>STATUS</Table.Cell>
                                        <Table.Cell>
                                            <Label color={status_color} size='large' image>
                                                <Icon name={status_icon} />
                                                {selectedQuote.status.toUpperCase()}
                                            </Label>
                                        </Table.Cell>
                                    </Table.Row>
                                </Table.Body>
                            </Table>
                        </Segment>
                        <Segment>
                            <Icon name='address book' /><b>Billing Details</b><br /><br />
                            {selectedQuote.quote_details.customer.name}<br />
                            {selectedQuote.quote_details.customer.company}<br />
                            {selectedQuote.quote_details.customer.address.address_1}<br />
                            {(selectedQuote.quote_details.customer.address.address_2.length > 0) && selectedQuote.quote_details.customer.address.address_2}<br />
                            {selectedQuote.quote_details.customer.address.postcode} {selectedQuote.quote_details.customer.address.town_city}<br />
                            {selectedQuote.quote_details.customer.address.state}<br />
                            {selectedQuote.quote_details.customer.address.country}<br />
                            <br />
                            <Icon name='mobile' /><a href={'tel:' + selectedQuote.quote_details.customer.mobile}>{selectedQuote.quote_details.customer.mobile}</a><br />
                            <Icon name='mail' /><a href={'mailto:' + selectedQuote.quote_details.customer.email}>{selectedQuote.quote_details.customer.email}</a>
                        </Segment>
                        <Segment>
                            <Icon name='shipping' /><b>Shipping Details</b><br /><br />
                            {(selectedQuote.quote_details.recipient)
                                ? (<div>
                                    {selectedQuote.quote_details.recipient.name}<br />
                                    {selectedQuote.quote_details.recipient.address.address_1}<br />
                                    {(selectedQuote.quote_details.recipient.address.address_2.length > 0) && selectedQuote.quote_details.recipient.address.address_2}
                                    {selectedQuote.quote_details.recipient.address.postcode} {selectedQuote.quote_details.recipient.address.town_city}<br />
                                    {selectedQuote.quote_details.recipient.address.state}<br />
                                    {selectedQuote.quote_details.recipient.address.country}<br />
                                    <br />
                                    {(selectedQuote.quote_details.recipient.phone.length > 0) && <a href={'tel:' + selectedQuote.quote_details.recipient.phone}>{selectedQuote.quote_details.recipient.phone}</a>}
                                </div>
                                )
                                : (<div>
                                    {selectedQuote.quote_details.customer.name}<br />
                                    {selectedQuote.quote_details.customer.address.address_1}<br />
                                    {(selectedQuote.quote_details.customer.address.address_2.length > 0) && selectedQuote.quote_details.customer.address.address_2}
                                    {selectedQuote.quote_details.customer.address.postcode} {selectedQuote.quote_details.customer.address.town_city}<br />
                                    {selectedQuote.quote_details.customer.address.state}<br />
                                    {selectedQuote.quote_details.customer.address.country}<br />
                                    <br />
                                    {(selectedQuote.quote_details.customer.mobile.length > 0) && <a href={'tel:' + selectedQuote.quote_details.customer.mobile}>{selectedQuote.quote_details.customer.mobile}</a>}
                                </div>
                                )
                            }
                        </Segment>
                    </Segment.Group>
                    <Segment>
                        <Accordion fluid>
                            <Accordion.Title active={cartOpen} onClick={this.handleCartClick.bind(this)}>
                                <Icon name='shopping bag' /><b>Products</b><Icon name='dropdown' />
                            </Accordion.Title>
                            <Accordion.Content active={cartOpen}>
                                <Table selectable style={{ wordBreak: 'break-word' }}>
                                    <Table.Header>
                                        <Table.Row>
                                            <Table.HeaderCell textAlign='left'>SKU</Table.HeaderCell>
                                            <Table.HeaderCell textAlign='left'>Description</Table.HeaderCell>
                                            <Table.HeaderCell textAlign='right'>Price</Table.HeaderCell>
                                        </Table.Row>
                                    </Table.Header>
                                    <Table.Body>
                                        {
                                            selectedQuote.quote_details.items.map((item) => (
                                                <Table.Row key={item.id}>
                                                    <Table.Cell>{item.product}</Table.Cell>
                                                    <Table.Cell>
                                                        <Table celled>
                                                            <Table.Body>
                                                                {
                                                                    Object.keys(item.configurations).map(key => {
                                                                        let value = item.configurations[key];
                                                                        if (key === 'size') {
                                                                            value = (value.type) ? `${value.type}` : `${value.height} mm x ${value.width} mm`;
                                                                        } else if (key === 'weight') {
                                                                            value = `${value} KG`;
                                                                        }

                                                                        return (
                                                                            <Table.Row key={key}>
                                                                                <Table.Cell>{capitalizeKey(key)}</Table.Cell>
                                                                                <Table.Cell>{value}</Table.Cell>
                                                                            </Table.Row>
                                                                        )
                                                                    })
                                                                }
                                                                <Table.Row>
                                                                    <Table.Cell>Unit Price</Table.Cell>
                                                                    <Table.Cell>{item.unit_price}</Table.Cell>
                                                                </Table.Row>
                                                            </Table.Body>
                                                        </Table>
                                                        {(item.adjustment_value !== 0) && (item.adjustment_value) &&
                                                            <Table celled>
                                                                <Table.Body>
                                                                    <Table.Row>
                                                                        <Table.Cell>
                                                                            Original Price
                                                                    </Table.Cell>
                                                                        <Table.Cell>
                                                                            RM {item.original_price.toFixed(2)}
                                                                        </Table.Cell>
                                                                    </Table.Row>
                                                                    <Table.Row>
                                                                        <Table.Cell>
                                                                            Adjustment
                                                                    </Table.Cell>
                                                                        <Table.Cell>
                                                                            RM {item.adjustment_amount.toFixed(2)} {(item.adjustment_type === '%') && '(' + item.adjustment_value.toFixed(2) + '%)'}
                                                                        </Table.Cell>
                                                                    </Table.Row>
                                                                </Table.Body>
                                                            </Table>
                                                        }
                                                    </Table.Cell>
                                                    <Table.Cell textAlign='right'>RM {item.price.toFixed(2)}</Table.Cell>
                                                </Table.Row>
                                            ))
                                        }
                                    </Table.Body>
                                    <Table.Footer>
                                        <Table.Row>
                                            <Table.HeaderCell></Table.HeaderCell>
                                            <Table.HeaderCell textAlign='right'>SUBTOTAL</Table.HeaderCell>
                                            <Table.HeaderCell textAlign='right'>RM {selectedQuote.quote_details.subtotal.toFixed(2)}</Table.HeaderCell>
                                        </Table.Row>
                                        <Table.Row>
                                            <Table.HeaderCell></Table.HeaderCell>
                                            <Table.HeaderCell textAlign='right'>ADJUSTMENT {(selectedQuote.quote_details.adjustment_type === '%') && <span>({selectedQuote.quote_details.adjustment_value} {selectedQuote.quote_details.adjustment_type})</span>}</Table.HeaderCell>
                                            <Table.HeaderCell textAlign='right'>RM {selectedQuote.quote_details.adjustment_amount.toFixed(2)}</Table.HeaderCell>
                                        </Table.Row>
                                        <Table.Row>
                                            <Table.HeaderCell></Table.HeaderCell>
                                            <Table.HeaderCell textAlign='right'>SHIPPING ({selectedQuote.quote_details.delivery_option})</Table.HeaderCell>
                                            <Table.HeaderCell textAlign='right'>RM {selectedQuote.quote_details.shipping_fee.toFixed(2)}</Table.HeaderCell>
                                        </Table.Row>
                                        {(selectedQuote.quote_details.shipping_disc > 0) &&
                                            (<Table.Row>
                                                <Table.HeaderCell></Table.HeaderCell>
                                                <Table.HeaderCell textAlign='right'>DISCOUNT (Shipping)</Table.HeaderCell>
                                                <Table.HeaderCell textAlign='right'>RM -{selectedQuote.quote_details.shipping_disc.toFixed(2)}</Table.HeaderCell>
                                            </Table.Row>)
                                        }

                                        <Table.Row>
                                            <Table.HeaderCell></Table.HeaderCell>
                                            <Table.HeaderCell textAlign='right'><b>TOTAL</b></Table.HeaderCell>
                                            <Table.HeaderCell textAlign='right'><b>RM {selectedQuote.quote_details.total_amount.toFixed(2)}</b></Table.HeaderCell>
                                        </Table.Row>
                                    </Table.Footer>
                                </Table>
                            </Accordion.Content>
                        </Accordion>
                    </Segment>
                    <Segment>
                        <Icon name='tasks' /><b>Additional Information</b><br /><br />
                        {(selectedQuote.quote_details.notes.length > 0) && <Message warning header='Customer Notes' size='small' content={selectedQuote.quote_details.notes} />}
                        <Accordion fluid>
                            <Accordion.Title active={logOpen} onClick={this.handleLogClick.bind(this)}>
                                <Icon name='file text outline' /><b>Transaction Logs</b><Icon name='dropdown' />
                            </Accordion.Title>
                            <Accordion.Content active={logOpen}>
                                {this.renderLogs(selectedQuote)}
                            </Accordion.Content>
                        </Accordion>
                    </Segment>
                    {
                        ((selectedQuote.status !== 'Canceled') && (selectedQuote.status !== 'Approved')) &&
                        <Segment textAlign='right'>
                            <Button icon='trash' content='Cancel Quotation' negative onClick={this.handlecancelQuote.bind(this)} />
                            <Button icon='check' content='Approve Quotation' positive onClick={this.handleprocessQuote.bind(this)} />
                        </Segment>
                    }
                </Segment.Group>
                <Modal size='small' open={addNoteDialog} onClose={this.closeAddNoteDialog.bind(this)} className='scrolling' closeIcon>
                    <Header icon='edit' content='Add Note' />
                    <Modal.Content>
                        <Form>
                            <Form.TextArea label='Note' value={miscNote} onChange={this.handleMiscNoteInput.bind(this)} />
                        </Form>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button negative onClick={this.closeAddNoteDialog.bind(this)} >
                            <Icon name='remove' /> Cancel
                        </Button>
                        <Button positive onClick={this.submitNote.bind(this)} disabled={miscNote.length === 0}>
                            <Icon name='checkmark' /> Submit
                        </Button>
                    </Modal.Actions>
                </Modal>
                <Modal open={processDialog} onClose={this.closeProcessDialog.bind(this)} className='scrolling' closeIcon>
                    <Header icon='cube' content='Approve Quote' />
                    <Modal.Content>
                        <p>Confirm approve quotation?</p>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button negative onClick={this.closeProcessDialog.bind(this)} >
                            <Icon name='remove' /> No
                        </Button>
                        <Button positive onClick={this.approveQuote.bind(this)}>
                            <Icon name='checkmark' /> Yes
                        </Button>
                    </Modal.Actions>
                </Modal>
                <Modal size='small' open={cancelDialog} closeOnEscape={false} closeOnRootNodeClick={false} onClose={this.closeCancelDialog.bind(this)} className='scrolling'>
                    <Header icon='trash' content='Cancel Quote' />
                    <Modal.Content>
                        <p>Are you sure you want to CANCEL this order?</p>
                        <Form>
                            <Form.TextArea label='Cancellation Note' value={cancellationNote} placeholder='Please enter the reason for cancellation and refund status (if any) to proceed.' onChange={this.handleCancellationNoteInput.bind(this)} />
                        </Form>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button negative onClick={this.closeCancelDialog.bind(this)} >
                            <Icon name='remove' /> No
                        </Button>
                        <Button positive onClick={this.cancelQuote.bind(this)} disabled={cancellationNote.length === 0}>
                            <Icon name='checkmark' /> Yes
                        </Button>
                    </Modal.Actions>
                </Modal>
            </div>
        )
    }
}

const mapStateToProps = ({ quote, auth }) => {
    return {
        quote,
        user: {
            _id: auth.user._id,
            name: auth.user.name,
            email: auth.user.email
        }
    }
}

const matchDispatchToProps = (dispatch) => {
    return bindActionCreators({
        processQuote: processQuote,
        cancelQuote: cancelQuote,
        addNoteQuotation: addNoteQuotation,
    }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(QuotationDetails);